// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* /Users/jonas/Coding/stormini_react/src/components/stadtplan/Stadtplan.css */
.stadtplan-container {
  position: relative; /* For absolute positioning of marker and image transform */
  width: 100%;
  max-width: 90vw; /* Example max-width */
  height: 60vh; /* Example height, adjust as needed */
  max-height: 600px; /* Example max-height */
  overflow: hidden; /* This is key to make zoom/pan work like a viewport */
  /* border: 3px solid var(--primary-dark); /* Design-angepasster Rahmen */
  margin: 20px auto; /* Center the container */
  /* cursor is set dynamically in JS: grab / grabbing */
  background-color: none; /* Design-angepasster Hintergrund */
  touch-action: none; /* Prevent default browser touch actions like scroll/zoom */
  -webkit-touch-callout: none; /* Disable callouts on long press (iOS) */
  user-select: none; /* Disable text selection */
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10+ */
}

.stadtplan-image {
  max-width: none;
  display: block; /* Remove extra space below image */
  /* transform-origin and transform will be set by inline style */
   -webkit-user-drag: none; /* Prevent image ghost dragging in Safari/Chrome */
   /* cursor is set dynamically in JS */
 }

 .stadtplan-message {
   position: absolute;
   top: 50%;
 }

.stadtplan-marker {
  position: absolute;
  width: 50px;
  height: 50px;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 10;
}

.section-title.blue {
  color: #0074b3 !important;
}

@media (max-width: 600px) {
  .section-title.blue {
    font-size: 2.5rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/stadtplan/Stadtplan.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;EACE,kBAAkB,EAAE,2DAA2D;EAC/E,WAAW;EACX,eAAe,EAAE,sBAAsB;EACvC,YAAY,EAAE,qCAAqC;EACnD,iBAAiB,EAAE,uBAAuB;EAC1C,gBAAgB,EAAE,sDAAsD;EACxE,wEAAwE;EACxE,iBAAiB,EAAE,yBAAyB;EAC5C,qDAAqD;EACrD,sBAAsB,EAAE,mCAAmC;EAC3D,kBAAkB,EAAE,2DAA2D;EAC/E,2BAA2B,EAAE,yCAAyC;EACtE,iBAAiB,EAAE,2BAA2B;EAC9C,yBAAyB,EAAE,WAAW;EACtC,qBAAqB,EAAE,WAAW;AACpC;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,mCAAmC;EACnD,+DAA+D;GAC9D,uBAAuB,EAAE,kDAAkD;GAC3E,oCAAoC;CACtC;;CAEA;GACE,kBAAkB;GAClB,QAAQ;CACV;;AAED;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* /Users/jonas/Coding/stormini_react/src/components/stadtplan/Stadtplan.css */\n.stadtplan-container {\n  position: relative; /* For absolute positioning of marker and image transform */\n  width: 100%;\n  max-width: 90vw; /* Example max-width */\n  height: 60vh; /* Example height, adjust as needed */\n  max-height: 600px; /* Example max-height */\n  overflow: hidden; /* This is key to make zoom/pan work like a viewport */\n  /* border: 3px solid var(--primary-dark); /* Design-angepasster Rahmen */\n  margin: 20px auto; /* Center the container */\n  /* cursor is set dynamically in JS: grab / grabbing */\n  background-color: none; /* Design-angepasster Hintergrund */\n  touch-action: none; /* Prevent default browser touch actions like scroll/zoom */\n  -webkit-touch-callout: none; /* Disable callouts on long press (iOS) */\n  user-select: none; /* Disable text selection */\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10+ */\n}\n\n.stadtplan-image {\n  max-width: none;\n  display: block; /* Remove extra space below image */\n  /* transform-origin and transform will be set by inline style */\n   -webkit-user-drag: none; /* Prevent image ghost dragging in Safari/Chrome */\n   /* cursor is set dynamically in JS */\n }\n\n .stadtplan-message {\n   position: absolute;\n   top: 50%;\n }\n\n.stadtplan-marker {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: 10;\n}\n\n.section-title.blue {\n  color: #0074b3 !important;\n}\n\n@media (max-width: 600px) {\n  .section-title.blue {\n    font-size: 2.5rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
